<template>
  <v-layout mt-6 wrap>
    <v-flex xs12>
      <v-card-title>Set distributors for this address (optional)</v-card-title>
    </v-flex>
    <v-flex>
      <v-layout
        v-for="(category, index) in distributorSettings"
        :key="index"
        wrap
      >
        <v-flex xs12 sm3>
          <v-subheader>{{ category.name }}</v-subheader>
        </v-flex>
        <v-flex xs10 sm8 md6 pr-4>
          <v-select
            v-model="distributorSettings[index].distributor"
            :items="distributors"
            :item-text="distributorDisplay"
            :item-value="distributorValue"
            outlined
            dense
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import request from "@/modules/request";

export default {
  name: "SetDistributors",
  props: {
    distributorSettings: {
      type: Array,
      required: true,
    },
    distributors: {
      type: Array,
      required: true,
    },
  },
  watch: {
    distributorSettings(val) {
      this.$emit("update:distributorSettings", val);
    },
  },
  methods: {
    initializeDistributorSettings() {
      const { categories } = this;
      this.distributorSettings = categories.map((category) => {
        return {
          category: category._id,
          name: category.name,
          distributor: null,
        };
      });
    },
    distributorDisplay(distributor) {
      return `${distributor.distributor.name} | ${distributor.address.name} | ${distributor.address.formatted_address}`;
    },
    distributorValue(distributor) {
      return distributor._id;
    },
  },
};
</script>
